export const POST_PROPERTYTYPES = 'POST_PROPERTYTYPES';
export const LIST_PROPERTYTYPES = 'LIST_PROPERTYTYPES';
